var $header = $('.password_header');

function checkScroll() {
    var scrollPosition = $(window).scrollTop();

    if (scrollPosition >= 120) {
        $header.addClass('scrolled');
    } else {
        $header.removeClass('scrolled');
    }
}



$(document).ready(function(){

$('.tab-menu li span').on('click', function() {
    var target = $(this).attr('data-rel');

    if ($(this).hasClass('active')) {
        // If the clicked tab is already active, deactivate it
        $(this).removeClass('active');
        $(".tab-box[id='"+target+"']").removeClass('active');
    } else {
        // Otherwise, activate the clicked tab and deactivate others
        $('.tab-menu li span').removeClass('active');
        $(this).addClass('active');
        $(".tab-box").removeClass('active');
        $(".tab-box[id='"+target+"']").addClass('active');
    }
});

  
// Image LookBook
  $('.image-loolbook-wrapper .image-count li').on('click', function() {
      const _this = $(this);
      const imageId = _this.data('image');
      const selector = _this.parents('.multicolumn-list__item');
      selector.find('.multicolumn-card').hide();
      selector.find('.image-count li').removeClass('active');
      _this.addClass('active');
      selector.find(`a[data-handle-id="${imageId}"]`).show();
      $('html').css("overflow", "hidden");
  });
  setTimeout(function() {
    $('.image-loolbook-wrapper li').magnificPopup({
        delegate: 'a',
        type: 'image',
        tLoading: 'Loading image #%curr%...',
      closeOnBgClick: false,
        // preloader: false,
        mainClass: 'mfp-img-mobile',
        gallery: {
            enabled: true,
            navigateByImgClick: false,
            preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
        },
        image: {
            tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
            titleSrc: function(item) {
                return '';
            }
        }
    });
}, 500);

 

  $(document).on('click', '.cdesk_contact_drawer, .product__text a', function(){
      $(".contact__main").addClass("active");
      $('.header-wrapper').addClass('contact_header_color');
      $("body").addClass("overflow___hidden");
      $('.header-wrapper').removeClass('sticky_header_color');
      $('.section-header').removeClass('menu-open');
      $('body').removeClass('overflow__hidden');
      $('.menu-drawer-container').removeClass('menu-opening');
      $('.menu-drawer-container').removeAttr('open');
      $('.menu-drawer-container .header__icon--menu').attr("aria-expanded","false");
    
      $('.cdesk_mega_menu').removeAttr('open');
      $('.cdesk_mega_menu .header__menu-item').attr("aria-expanded","false");
      let menuTextElement = $('.cdesk_mega_menu span');
      let menuText = menuTextElement.innerHTML;
      if (menuText === "Close") {
        menuTextElement.innerHTML = 'Menu';
      } else {
        menuTextElement.innerHTML = 'Menu';
      }
  });
  
  $(".drawer_form_close").click(function() {
      $(".contact__main").removeClass("active");
      $('body').removeClass('overflow___hidden');
      $('.header-wrapper').removeClass('contact_header_color');
  });
  
  // $(".drawer-cart").click(function() {
  //     $(".main-cart-drawer").addClass("active");
  //     $("body").addClass("overflow__hidden");
  // });

  $(document).on('mouseup', function(event) {
      if (!$(event.target).closest(".contact.drawer__inner, .cdesk_contact_drawer, .product__text a").length) {
          $(".contact__main").removeClass("active");
          $("body").removeClass("overflow___hidden");
          $('.header-wrapper').removeClass('contact_header_color');
      }
  });

  $(document).on('click', '.round', function(){
    $(this).parents('.filter_section').find('.mobile-facets__item[filter-type="in-stock"] input').click();
    $(this).parents(".switch").toggleClass("active-toggle");
  })
   $(document).on('click', '.active-availability', function(e){
    $('.switch').removeClass('active-toggle');
  })

  var checkInput = $('.filter_section').find('.mobile-facets__item[filter-type="in-stock"] input').is(":checked");
  if (checkInput){
    console.log('checkInput::'+checkInput);
    $(".switch").removeClass("active-toggle");
  }
  else{
    $(".switch").addClass("active-toggle");
    console.log('not checked checkInput');
  }
  $(document).on('click','.mobile-facets__item .facets__label', function(){
    $(this).parents('.mobile-facets__item').siblings('.mobile-facets__item').addClass('disabled');
  })

  $(document).on('click', '.product-form__buttons .product-form__submit.disabled', function(e){
    e.preventDefault();
    // console.log('click');
      $('.cdk_error_message').addClass('cdk_error_message_show');    
  });
  $(document).on('click', '.product-form__buttons .product-form__submit.disabled', function(e){
    e.preventDefault();
    // console.log('click');
      $('.cdk_error_message').addClass('cdk_error_message_show');    
  });
  // $(document).on('click', 'header-drawer', function(e){
  //   var cartCount = $(this).siblings('.header__icon--cart').find('.cdk-hmcart-icon').attr('data-count');
  //   console.log('cartCount::'+cartCount);
  //     // $('.cdk_error_message').addClass('cdk_error_message_show');
  //   $('.drawer-cart.header__icon .cart__counter').text(cartCount);
  // });
  $(document).on("mouseenter", ".header__inline-menu .list-menu li",function () {
      var dataImg = $(this).attr("data-image")
      console.log('dataImg::'+dataImg);
      $(".mega_img_side img").attr("src", dataImg);
  })
  var currentPage = $('.header__inline-menu .list-menu li.current-page').attr('data-image');
  console.log('currentPage::'+currentPage);
  if(currentPage != undefined){
    $(".mega_img_side img").attr("src", currentPage);
  }
});
// 


/****************16-05-2024 Product Gallery**********************/
$(document).ready(function(){

  $(document).on("click", ".cdesk_mega_menu .header-parent-link", function () {
    // event.stopPropagation();
    var thistext = $(this).text();
    if(thistext == "Menu"){
      $(this).text('Close');
      $('body').addClass('overflow__hidden');
    }
    else{
      $(this).text('Menu');
      $('body').removeClass('overflow__hidden');
    }
    // Prevent the event from propagating to the document
    $("sticky-header").toggleClass("sticky_header_color");
    // $("body").toggleClass("overflow__hidden");
  });

  
  $('.cdk-product-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots:false,
    arrows: true,
    fade: true,
    cssEase: 'linear',
    prevArrow: '<button class="slide-arrow prev-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" fill="white" fill-opacity="0.01" style="mix-blend-mode:multiply"/><path d="M7.5 12L15 4.5L16.05 5.55L9.6 12L16.05 18.45L15 19.5L7.5 12Z" fill="#909483"/></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" fill="white" fill-opacity="0.01" style="mix-blend-mode:multiply"/><path d="M16.5002 12L9.0002 19.5L7.9502 18.45L14.4002 12L7.9502 5.55L9.0002 4.5L16.5002 12Z" fill="#909483"/></svg></button>'
  });

// review slider 

$('.review__slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  dots:false,
  arrows: true,
  speed: 800,
  infinite: true,
  cssEase: 'linear',
  prevArrow: '<button class="btn-prev slick-arrow"><svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="56" y="56" width="56" height="56" rx="28" transform="rotate(180 56 56)" fill="#DBE0C6"/><path d="M36 29C36.5523 29 37 28.5523 37 28C37 27.4477 36.5523 27 36 27L36 29ZM19.2929 27.2929C18.9024 27.6834 18.9024 28.3166 19.2929 28.7071L25.6569 35.0711C26.0474 35.4616 26.6805 35.4616 27.0711 35.0711C27.4616 34.6805 27.4616 34.0474 27.0711 33.6569L21.4142 28L27.0711 22.3431C27.4616 21.9526 27.4616 21.3195 27.0711 20.9289C26.6805 20.5384 26.0474 20.5384 25.6569 20.9289L19.2929 27.2929ZM36 27L20 27L20 29L36 29L36 27Z" fill="#52544A"/></svg></button>',
  nextArrow: '<button class="btn-next slick-arrow"><svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="56" height="56" rx="28" fill="#DBE0C6"/><path d="M20 27C19.4477 27 19 27.4477 19 28C19 28.5523 19.4477 29 20 29V27ZM36.7071 28.7071C37.0976 28.3166 37.0976 27.6834 36.7071 27.2929L30.3431 20.9289C29.9526 20.5384 29.3195 20.5384 28.9289 20.9289C28.5384 21.3195 28.5384 21.9526 28.9289 22.3431L34.5858 28L28.9289 33.6569C28.5384 34.0474 28.5384 34.6805 28.9289 35.0711C29.3195 35.4616 29.9526 35.4616 30.3431 35.0711L36.7071 28.7071ZM20 29H36V27H20V29Z" fill="#52544A"/></svg></button>',
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        arrows: false,
        autoplay:true,
        adaptiveHeight: true
      }
    }
  ]
});

$('.subi_index .image_card2').slick({
  responsive: [
    {
      breakpoint: 9999,
      settings: "unslick"
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1.1,
        centerMode: true,
        centerPadding: '28px',
        arrows:false,
        dots:false,
        slidesToScroll: 1,
      }
    }
   ]
  });  

// $('.image_card').slick({
//   responsive: [
//     {
//       breakpoint: 9999,
//       settings: "unslick"
//     },
//     {
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 1.1,
//         centerMode: true,
//         centerPadding: '27px',
//         arrows:false,
//         dots:false,
//         slidesToScroll: 1
//       }
//     }
//    ]
//   });  

  $('.collection__slider').slick({
  dots: false,
  arrow: true,          
  infinite: false,
  speed: 300,
  prevArrow: '<button class="slide-arrow prev-arrow slider-button slider-button--prev"><svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 9C17.5523 9 18 8.55228 18 8C18 7.44772 17.5523 7 17 7L17 9ZM0.292892 7.29289C-0.0976315 7.68342 -0.0976314 8.31658 0.292893 8.70711L6.65686 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928933C7.68054 0.538409 7.04738 0.538409 6.65685 0.928933L0.292892 7.29289ZM17 7L1 7L1 9L17 9L17 7Z" fill="#52544A"></path></svg></button>',
  nextArrow: '<button class="slide-arrow next-arrow slider-button slider-button--next"><svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 7C0.447715 7 0 7.44772 0 8C0 8.55228 0.447715 9 1 9V7ZM17.7071 8.70711C18.0976 8.31658 18.0976 7.68342 17.7071 7.29289L11.3431 0.928932C10.9526 0.538408 10.3195 0.538408 9.92893 0.928932C9.53841 1.31946 9.53841 1.95262 9.92893 2.34315L15.5858 8L9.92893 13.6569C9.53841 14.0474 9.53841 14.6805 9.92893 15.0711C10.3195 15.4616 10.9526 15.4616 11.3431 15.0711L17.7071 8.70711ZM1 9H17V7H1V9Z" fill="#52544A"/></svg></button>',
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        arrow: false,
        prevArrow: '',
        nextArrow: '',
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});

$('.cdk_faetureblog_slider').slick({
  responsive: [
    {
      breakpoint: 9999,
      settings: "unslick"
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '20px',
        arrows:false,
        dots:false,
        slidesToScroll: 1
      }
    }
   ]
  });  
  

  
// PDP size guide popup
  // $('.size-guide').click(function() {
  //   $('.product-popup-modal__button').click();
  // });


// Loop through all navigation links
  // $('.footer-block__details-content li a').each(function() {
  //     if ($(this).text().trim() === 'Contact Us') {
  //         $(this).on('click', function(event) {
  //             event.preventDefault();
  //             $('#contact-popup').fadeIn();
  //         });
  //     }
  // });

  // document.addEventListener('click', function(event) {
  //   const drawer = document.querySelectorAll('Details-menu-drawer-container');
  //   const closeButton = drawer.querySelectorAll('.header__icon--close');

  //   if (event.target === closeButton || !drawer.contains(event.target)) {
  //     drawer.removeAttribute('open');  // Close the drawer
  //   }
  // });


    $(".size-guide-scroll").click(function(){
      $('.size-guide-section').show();
        $('html, body').animate({
            scrollTop: $("#size_guide").offset().top
        },700);
    });
 

    // video list
    $(document).on("click", ".cover_image .video-play", function () {
      $(this).parents(".cover-img-video").find("video").trigger("play");
      $(this).parents(".cover-img-video").find(".cover_image").hide();
      $(this).parents(".video").siblings().find(".cover-img-video video").trigger("pause");
      $(this).parents(".video").siblings().find(".cover-img-video .cover_image").show();
    });
    $(".video .video-sound").click(function (e) {
      var VideoSoundD = $(this).parents(".cover-img-video").find("video");
      if (VideoSoundD.prop("muted", true)) {
        VideoSoundD.prop("muted", false);
      } else VideoSoundD.prop("muted", false);
      {
        VideoSoundD.prop("muted", true);
      }
    });

  $('.video-list-wrapper').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      speed: 300,
      infinite: true,
      autoplaySpeed: 5000,
      autoplay: false,
      swipeToSlide: true,
      prevArrow: '<div class="slide-arrow prev-arrow"><svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="52" height="52" rx="26" transform="matrix(-1 0 0 1 52 0)" fill="#f8faf0" fill-opacity="0.8"/><path d="M30.1117 36L31.8867 34.225L23.6617 26L31.8867 17.775L30.1117 16L20.1117 26L30.1117 36Z" fill="#42403b"/></svg></button>',
      nextArrow: '<div class="slide-arrow next-arrow"><svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="52" height="52" rx="26" fill="#f8faf0" fill-opacity="0.8"/><path d="M21.8873 36L20.1123 34.225L28.3373 26L20.1123 17.775L21.8873 16L31.8873 26L21.8873 36Z" fill="#42403b"/></svg></button>',
      responsive: [
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2.3,
          }
        },
        {
          breakpoint: 767,
          settings: {
            infinite: false,
            // centerMode: true,
            // centerPadding: "20px",
            slidesToShow: 1.27,
          }
        }
      ]
  });  


  function tabSlider() {
    $('.tabs_slider').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      prevArrow: '<button class="slide-arrow prev-arrow slider-button slider-button--prev"><svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 9C17.5523 9 18 8.55228 18 8C18 7.44772 17.5523 7 17 7L17 9ZM0.292892 7.29289C-0.0976315 7.68342 -0.0976314 8.31658 0.292893 8.70711L6.65686 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928933C7.68054 0.538409 7.04738 0.538409 6.65685 0.928933L0.292892 7.29289ZM17 7L1 7L1 9L17 9L17 7Z" fill="#52544A"></path></svg></button>',
      nextArrow: '<button class="slide-arrow next-arrow slider-button slider-button--next"><svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 7C0.447715 7 0 7.44772 0 8C0 8.55228 0.447715 9 1 9V7ZM17.7071 8.70711C18.0976 8.31658 18.0976 7.68342 17.7071 7.29289L11.3431 0.928932C10.9526 0.538408 10.3195 0.538408 9.92893 0.928932C9.53841 1.31946 9.53841 1.95262 9.92893 2.34315L15.5858 8L9.92893 13.6569C9.53841 14.0474 9.53841 14.6805 9.92893 15.0711C10.3195 15.4616 10.9526 15.4616 11.3431 15.0711L17.7071 8.70711ZM1 9H17V7H1V9Z" fill="#52544A"/></svg></button>',
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 767,
          settings: {
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
  tabSlider();

  $(document).on("click", ".tab-link", function () {
    var thisdataTab = $(this).attr("data-tab-heading");
    var tabHeading = $(this).data('heading'); 
    $('.main-title .value').text(tabHeading);
    $('.tab-link').removeClass('active');
    $(this).addClass('active');
    $(this).parents(".collection-cdk-tab-slider").find('.tab-content').hide();
    $(this).parents(".collection-cdk-tab-slider").find('.tab-content[data-tab-content="' + thisdataTab + '"]').show();
    $(this).parents(".collection-cdk-tab-slider").find('.tab-content').removeClass('active');
    $(this).parents(".collection-cdk-tab-slider").find('.tab-content[data-tab-content="' + thisdataTab + '"]').addClass('active');
    $('.tabs_slider').slick('destroy');
    tabSlider();
  });
  
  $(document).on("click", ".custom_facet .custom_facet_name", function () {
    var facetChange = $(this).attr("value_change");
    // console.log(facetChange);
    $(".cdksortby select option[value='" +facetChange+ "']").attr('selected', 'selected');
    $(".facet-filters__sort").val(facetChange).change();
    $(".custom_facet").removeClass("active");
    $(this).parents(".custom_facet").addClass("active");
    $(".collection .loading-overlay").show();
  });
  $(document).on('change', '.facet-filters__sort', function() {
    var sortBy = $(this).val();
    var pageURL = $(location).attr("href");
   // Find the index of "sort_by="
    var startIndex = pageURL.indexOf("sort_by=");
  
    if (startIndex !== -1) {
    // Extract the text after "sort_by="
    var textAfterSortBy = pageURL.substring(startIndex + "sort_by=".length);
  
    // Remove the extracted text from the URL
    var modifiedURL = pageURL.replace(textAfterSortBy, "");
   var newUrl = modifiedURL+sortBy+'&';
    console.log("Modified URL: " + modifiedURL);
    }
    else if (document.URL.indexOf("search") > -1) { 
       var modifiedURL = pageURL;
      var newUrl = modifiedURL+'&sort_by='+sortBy+'&';
    }
    else {
       var modifiedURL = pageURL;
      var newUrl = modifiedURL+'?sort_by='+sortBy+'&';
    }
    console.log('newUr::'+newUrl)
    // Perform an AJAX request to fetch the sorted products.
    $.ajax({
      type: 'GET',
      url: newUrl,
      data: "html",
      success: function(data) {
        history.pushState('data', '', newUrl);
        var productListing = $(data).find('#product-grid .grid__item');
        $('#product-grid:not(.template-search__results)').html(productListing);
        $('#product-grid.template-search__results .product-grid').html(productListing);
        $(".collection .loading-overlay").hide();
      }
    });
  });
   if (sessionStorage.getItem('productGridClass')) {
       $('#product-grid').addClass(sessionStorage.getItem('productGridClass'));
       if ($('#product-grid').hasClass('grid-two-in-row')) {
            $(".cdk_grid_layout .icon-grid").addClass("active");
            $(".cdk_grid_layout .icon-square").removeClass("active");
        } else {
            $(".cdk_grid_layout .icon-grid").removeClass("active");
            $(".cdk_grid_layout .icon-square").addClass("active");
        }
    }

    $(document).on('click', '.cdk_grid_layout', function() {
        $('#product-grid').toggleClass('grid-two-in-row');
        $('#product-grid').toggleClass('grid-one-in-row');

        // Store the current class in sessionStorage
        if ($('#product-grid').hasClass('grid-two-in-row')) {
            sessionStorage.setItem('productGridClass', 'grid-two-in-row');
          $(".cdk_grid_layout .icon-grid").addClass("active");
          $(".cdk_grid_layout .icon-square").removeClass("active");
        } else {
            sessionStorage.removeItem('productGridClass');
          $(".cdk_grid_layout .icon-grid").removeClass("active");
          $(".cdk_grid_layout .icon-square").addClass("active");
        }
    });
  
    $('.subi-project').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          speed: 300,
          infinite: false,
          autoplaySpeed: 5000,
          responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow:2.5,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow:1.2,
    		  slidesToScroll: 1,
            
          }
        }
      ]
    });

    // $('.cdk-collection-slider').slick({
    //       slidesToShow: 4,
    //       slidesToScroll: 1,
    //       arrows: true,
    //       dots: false,
    //       speed: 300,
    //       infinite: false,
    //       autoplaySpeed: 5000,
    //       responsive: [
    //     {
    //       breakpoint: 991,
    //       settings: {
    //         slidesToShow:3,
    //       }
    //     },
    //     {
    //       breakpoint: 767,
    //       settings: {
    //         slidesToShow:1.1,
    // 		  slidesToScroll: 1,
    //       }
    //     }
    //   ]
    // }); 

    $('.cdk-collection-slider').slick({
      arrows: true,
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1.1,
            slidesToScroll: 1
          }
        }
      ]
    });
    // $('.announcement-slider').slick({
    //   arrows: false,
    //   dots: false,
    //   infinite: false,
    //   speed: 500,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   autoplay: true,
    //   autoplaySpeed: 5000,
    // });

  	$(".prev-btn").click(function () {
		$(".cdk-collection-slider").slick("slickPrev");
	});

	$(".next-btn").click(function () {
		$(".cdk-collection-slider").slick("slickNext");
	});
	$(".prev-btn").addClass("slick-disabled");
	$(".cdk-collection-slider").on("afterChange", function () {
		if ($(".slick-prev").hasClass("slick-disabled")) {
			$(".prev-btn").addClass("slick-disabled");
		} else {
			$(".prev-btn").removeClass("slick-disabled");
		}
		if ($(".slick-next").hasClass("slick-disabled")) {
			$(".next-btn").addClass("slick-disabled");
		} else {
			$(".next-btn").removeClass("slick-disabled");
		}
	});

  
});
$(document).ready(function(){
  
 $(".cdk-title-icon").click(function(){
   
    $('.cdk-title-icon').not(this).removeClass('active');
     $('.cdk-answer').not($(this).closest('.cdk-title-icon').next('.cdk-answer')).removeClass('active');
     $(this).closest('.cdk-title-icon').next('.cdk-answer').toggleClass("active");
     $(this).toggleClass("active");
     $('.footer .localization-selector.disclosure__button.localization-form__select').attr('aria-expanded', 'false');
     $('footer.footer .localization-selector + .disclosure__list-wrapper.country-selector').attr('hidden', 'true');
 });

  $(document).on('click', 'footer.footer .localization-selector', function() {
    // p.preventDefault();
    $('.cdk-title-icon').removeClass('active');
    $('.cdk-answer').removeClass('active');
  });
  
 // $(".cdk-title-icon .icon-plus").click(function() {
 //     $(".cdk-title-icon").removeClass("active");
 //     $(this).closest(".cdk-title-icon").addClass("active");
 // });

 // $(".cdk-title-icon .icon-minus").click(function() {
 //     $(".cdk-title-icon").removeClass("active");
 // });
  if ($('.announcement-bar-main').length) {
      $('body').addClass('sticky-bar');
  }

});

window.onload = function() {
  var header = document.querySelector('.section-header');
  var bodyClass = $('body');
  if (window.pageYOffset > 100) {
    header.classList.add('scrolled-past-header');
    bodyClass.classList.add('previous-scroll-option');
  }
};